import {
  FETCH_BUCKETLIST_DATA_REQUEST,
  FETCH_BUCKETLIST_DATA_SUCCESS,
  FETCH_BUCKETLIST_DATA_FAILURE
} from "./types";

const initialState = {
  isLoading: false,
  error: "",
  bucketListData: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BUCKETLIST_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_BUCKETLIST_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        bucketListData: action.payload.data,

        error: ""
      };
    case FETCH_BUCKETLIST_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        bucketListData: [],

        error: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
